export function setQueryParam(key, value, pageRefresh, preserveBrowserHistory) {
  let url = new URL(window.location.href);
  url.searchParams.set(key, value);
  let newUrl = url.toString();

  if (pageRefresh) {
    window.location.href = newUrl;
  } else if (preserveBrowserHistory) {
    // TO MAINTAIN BROWSER HISTORY USE pushState();
    window.history.pushState({}, null, newUrl);
  } else {
    // TO ONLY UPDATE QUERY PARAMETER USE replaceState();
    window.history.replaceState({}, null, newUrl);
  }  
}

export function deleteQueryParam(key, pageRefresh, preserveBrowserHistory) {
  let url = new URL(window.location.href);
  url.searchParams.delete(key);
  let newUrl = url.toString();

  if (pageRefresh) {
    window.location.href = newUrl;
  } else if (preserveBrowserHistory) {
    // TO MAINTAIN BROWSER HISTORY USE pushState();
    window.history.pushState({}, null, newUrl);
  } else {
    // TO ONLY UPDATE QUERY PARAMETER USE replaceState();
    window.history.replaceState({}, null, newUrl);
  }
  
}

